import service from "../../services/gestionEmpleados/permissions";
import moment from "moment";

export default {
  namespaced: true,
  state: {
    service: new service(),
    permissions: [],
    new: {},
    deleteItem: {},
    editItems: {},
    openDelete: false,
    open: false,
    mode: "",
  },
  mutations: {
    setPermissions(state, data) {
      state.permissions = data;
    },
    setNew(state, data) {
      state.new = data;
    },
    setDeleteItem(state, data) {
      state.deleteItem = data;
    },
    setEdit(state, options) {
      state.editItems = options;
    },
    setOpen(state, data) {
      state.open = data;
    },
    setOpenDelete(state, data) {
      state.openDelete = data;
    },
    setMode(state, data) {
      state.mode = data;
    },
  },
  actions: {
    async getPermissions({ state, dispatch, commit }) {
      try {
        dispatch("loader/startLoading", null, { root: true });
        let item = await state.service.getPermissions();
        commit("setPermissions", item);
      } catch (error) {
        reject(error);
      } finally {
        dispatch("loader/stopLoading", null, { root: true });
      }
    },

    async new({ state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.new(state.new).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async delete({ state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.delete(state.deleteItem).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },

    async edit({ state, dispatch }) {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch("loader/startLoading", null, { root: true });
          await state.service.edit(state.editItems).then(() => {
            resolve(true);
          });
        } catch (error) {
          reject(error);
        } finally {
          dispatch("loader/stopLoading", null, { root: true });
        }
      });
    },
  },
};
